import { DateTime } from 'luxon';
import parseDate from '@/date';

export default function (value, format = DateTime.TIME_SIMPLE) {
    if (!value) {
        return '';
    }

    const dt = parseDate(value);

    return dt.toLocaleString(format);
}
